@if (data().link) {
  <a [href]="data().link!.href" [class]="cssClass()">
    <ng-container *ngTemplateOutlet="cardContent" />
  </a>
} @else {
  <div [class]="cssClass()">
    <ng-container *ngTemplateOutlet="cardContent" />
  </div>
}

<ng-template #cardContent>
  @if (data().variant === 'image' && data().imageSrc) {
    <div class="s__card-item__image">
      <img
        [ngSrc]="data().imageSrc!"
        [width]="data().imageWidth || 800"
        [height]="data().imageHeight || 600"
        [alt]="data().imageAlt ?? ''"
        sizes="(min-width: 1024px) 25vw, (min-width: 640px) 50vw, 100vw"
      />
    </div>
  }

  @if (data().variant === 'thumb-image' && data().imageSrc) {
    <div class="s__card-item__thumb">
      <img
        [src]="data().imageSrc!"
        [width]="data().imageWidth || 473"
        [height]="data().imageHeight || 473"
        [alt]="data().imageAlt ?? ''"
        loading="lazy"
        decoding="async"
      />
    </div>
  }

  @if (data().variant === 'headed' && data().heading) {
    <div class="s__card-item__header">
      <h3 class="s__card-item__heading">{{ data().heading }}</h3>
    </div>
  }

  <div class="s__card-item__body-area">
    @if (data().topRightLabel) {
      <div class="s__card-item__meta-row">
        <span class="s__card-item__top-right-label">{{ data().topRightLabel }}</span>
      </div>
    }
    @if (data().decorator) {
      <div class="s__card-item__decorator">
        @switch (data().decorator!.type) {
          @case ('number') {
            <span [class]="'s__card-item__decorator-number s__card-item__decorator-number--' + (data().decorator!.style ?? 'colored')">{{ data().decorator!.value }}</span>
          }
          @case ('label') {
            <span class="s__card-item__decorator-label">{{ data().decorator!.value }}</span>
          }
          @case ('icon') {
            <span class="s__card-item__decorator-icon" [innerHTML]="trustedIconSvg()"></span>
          }
          @case ('photo') {
            @if (data().decorator!.src) {
              <img
                [class]="'s__card-item__decorator-photo' + (data().decorator!.style === 'square' ? ' s__card-item__decorator-photo--square' : '')"
                [ngSrc]="data().decorator!.src!"
                [width]="data().decorator!.width || (data().decorator!.style === 'square' ? 64 : 256)"
                [height]="data().decorator!.height || (data().decorator!.style === 'square' ? 64 : 256)"
                [alt]="data().decorator!.alt ?? ''"
              />
            }
          }
        }
      </div>
    }

    @if (data().subhead) {
      <h3 class="s__card-item__subhead">{{ data().subhead }}</h3>
    }

    @if (data().body) {
      <div class="s__card-item__text" [innerHTML]="data().body"></div>
    }

    @if (data().footer) {
      <span class="s__card-item__footer">{{ data().footer }}</span>
    }

    @if (data().link) {
      @if (data().link!.style === 'arrow') {
        <span class="s__card-item__link-text">
          {{ data().link!.text ?? 'Learn more' }}
          <svg class="s__card-item__link-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16" aria-hidden="true">
            <path fill-rule="evenodd" d="M3 10a.75.75 0 0 1 .75-.75h10.638l-3.96-3.72a.75.75 0 1 1 1.024-1.06l5.25 4.93a.75.75 0 0 1 0 1.06l-5.25 4.93a.75.75 0 1 1-1.024-1.06l3.96-3.72H3.75A.75.75 0 0 1 3 10Z" clip-rule="evenodd"/>
          </svg>
        </span>
      }
      @if (data().link!.style === 'icon') {
        <span class="s__card-item__link-icon" [innerHTML]="trustedLinkIconSvg()"></span>
      }
      @if (data().link!.style === 'text') {
        <span class="s__card-item__link-text s__card-item__link-text--plain">{{ data().link!.text ?? 'Visit' }}</span>
      }
    }
  </div>
</ng-template>
